import React, { Component, useEffect, useState } from 'react';
import logo from '../images/logo.svg';
import {FaAlignRight} from "react-icons/fa";
import { FiAward } from "react-icons/fi";
import {Link} from 'react-router-dom';



function NavbarFunc() {
    const [isOpen, setIsOpen] = useState(false);

    const handleToggle = () => {
        setIsOpen(!isOpen);
    }
    return (
        <nav className="navbar">
            {/* {setIsOpen(!isOpen)} */}
            <div className="nav-center">
                <div className="nav-header">
                    <Link to="/">
                        <img src={logo} alt="Beach Resort"></img>
                    </Link>
                    <button 
                    onClick={handleToggle}
                    type="button" 
                    className="nav-btn">
                        <FaAlignRight className="nav-icon"/>
                    </button>
                </div>

                <ul 
                className={isOpen ? "nav-links show-nav" 
                : "nav-links"}>

                <li><Link to="/">Home</Link></li>
                <li><Link to="/rooms">Rooms</Link></li>
                </ul>
            </div>
        </nav>
    )
}

export default NavbarFunc

